import React, { useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { useTranslation } from 'react-i18next';
import PrivateLessonSettings from '../storeTabs/PrivateLessonSettings/PrivateLessonSettings';
import GroupLessonSettings from '../storeTabs/GroupLessonSettings/GroupLessonSetting';
import AutoAttendanceSettings from '../storeTabs/AutoAttendanceSettings';

// 수업 관리 > 설정. 센터 목록 > 센터 설정 > 레슨 설정의 같은 화면을 그대로 쓴다(같은 API·같은 저장 결과).
// 두 레슨 설정 컴포넌트는 branchId 만 쓴다(다른 props 는 받기만 함).
const subTabSx = {
  '& .MuiTab-root': {
    borderRadius: '8px', border: '1px solid #ddd', mr: 1.25, minWidth: '100px', minHeight: '36px !important',
    padding: '8px 20px', fontWeight: 500, fontSize: '13px', color: '#666', textTransform: 'none',
  },
  '& .MuiTab-root.Mui-selected': { background: '#262626', border: '1px solid #262626', color: '#fff' },
  '& .MuiTabs-indicator': { display: 'none' },
};

function ClassManageSettings({ branchId }) {
  const { t } = useTranslation();
  const [subTab, setSubTab] = useState('private');

  return (
    <Box sx={{ pt: 2, pb: 4 }}>
      <Tabs value={subTab} onChange={(_e, value) => setSubTab(value)} sx={subTabSx} aria-label="class settings tabs">
        <Tab value="private" label={t('Private Lesson Settings')} />
        <Tab value="group" label={t('Group Lesson Settings')} />
        <Tab value="auto" label={t('자동 출결 설정')} />
      </Tabs>
      {subTab === 'private' && <PrivateLessonSettings branchId={branchId} />}
      {subTab === 'group' && <GroupLessonSettings branchId={branchId} />}
      {subTab === 'auto' && <AutoAttendanceSettings branchId={branchId} />}
    </Box>
  );
}

export default ClassManageSettings;
